import React from 'react';
import PropTypes from 'prop-types';

export const DataScope = ({ operator, scopeValue, onDataScopeChange }) => {
  const operatorClass = (operator || '').toLowerCase();
  const operatorLabels = {
    central: 'Central Line',
    bakerloo: 'Bakerloo Line',
    jubilee: 'Jubilee Line',
  };
  const operatorLabel = operatorLabels[operatorClass] || operator || 'Fleet';

  return (
    <div className="dataScopeSelection" data-testid="data-scope-container">
      <div className="dataScopeSelection__field">
        <div className="chartControlTitle">Fleet</div>
        <div className="dataScopeSelection__fleetControl">
          <span
            className={`dataScopeSelection__fleetDot dataScopeSelection__fleetDot--${operatorClass}`}
            aria-hidden="true"
          />
          <span className="dataScopeSelection__fleetLabel" data-testid="data-scope-fleet-label">
            {operatorLabel}
          </span>
        </div>
      </div>
      <div className="dataScopeSelection__field">
        <div className="chartControlTitle">Data Scope</div>
        <select
          className="form-control"
          value={scopeValue}
          onChange={event => onDataScopeChange?.(event.target.value)}
          aria-label="Data Scope"
          data-testid="data-scope-select"
        >
          <option value="unit">Unit</option>
          <option value="consist">Consist</option>
        </select>
      </div>
    </div>
  );
};

DataScope.propTypes = {
  operator: PropTypes.string,
  scopeValue: PropTypes.oneOf(['unit', 'consist']).isRequired,
  onDataScopeChange: PropTypes.func,
};
